import { QueryParamsManager } from 'src/services/QueryParameterManager';
import { SYNTHETIC_TEST_INDICATOR } from 'src/services/QueryParameterManager/constants';

export const isSyntheticTest = () => !!QueryParamsManager.store[SYNTHETIC_TEST_INDICATOR];
